import {make_path,get_dirname} from './path_utils.js';
import {getAbsDir} from './paths.js';
export function getFunctionsDir(): string {
    return get_dirname(getAbsDir());
};


export function geAuthsUtilsDirectory():string{
    return make_path(getFunctionsDir(), 'auths');
}; 
export function geBackupsUtilsDirectory():string{
    return make_path(getFunctionsDir(), 'backups');
}; 
export function geConstantsUtilsDirectory():string{
    return make_path(getFunctionsDir(), 'constants');
}; 
export function geEnvUtilsDirectory():string{
    return make_path(getFunctionsDir(), 'env_utils');
}; 
export function geFetchUtilsDirectory():string{
    return make_path(getFunctionsDir(), 'fetch_utils');
}; 
export function geFileUtilsDirectory():string{
    return make_path(getFunctionsDir(), 'file_utils');
};
export function gePathUtilsDirectory():string{
    return make_path(getFunctionsDir(), 'path_utils');
}; 
export function geStringUtilsDirectory():string{
    return make_path(getFunctionsDir(), 'string_utils');
}; 
export function geTypeUtilsDirectory():string{
    return make_path(getFunctionsDir(), 'type_utils');
};